
import styles from './css/header.module.css';

export default function Header({children}){
    
    return (
        <div className={styles.component}>
            <div className={styles.container}>
                {children}
            </div>
        </div>
    )
}